import React, { useState, useEffect } from "react";
import "./admincontrols.css";

const GalleryManager = () => {
  const [mode, setMode] = useState("add"); // 'add' or 'update'
  const [galleryData, setGalleryData] = useState([]);
  const [formData, setFormData] = useState({
    year: "",
    title: "",
    tab_image: null,
    video: null,
    images: []
  });

  const [previewTabImage, setPreviewTabImage] = useState(null);
  const [previewVideo, setPreviewVideo] = useState(null);
  const [previewImages, setPreviewImages] = useState([]);
  const [message, setMessage] = useState("");
  const [config, setConfig] = useState(null);

  // Load config.json from public
  useEffect(() => {
    fetch("/config.json")
      .then(res => res.json())
      .then(data => setConfig(data))
      .catch(err => console.error("Failed to load config.json:", err));
  }, []);

  // Fetch gallery data for update
 useEffect(() => {
  if (mode === "update" && config) {
    fetch(`${config.BASE_URL}${config.GET_GALLERY}`)
      .then(res => res.json())
      .then(data => {
        if (data.success && Array.isArray(data.gallery)) {
          setGalleryData(data.gallery); // set only the array
        } else {
          setGalleryData([]); // fallback
        }
      })
      .catch(err => console.error(err));
  }
}, [mode, config]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "tab_image") {
      setFormData(prev => ({ ...prev, tab_image: files[0] }));
      setPreviewTabImage(URL.createObjectURL(files[0]));
    } else if (name === "video") {
      setFormData(prev => ({ ...prev, video: files[0] }));
      setPreviewVideo(URL.createObjectURL(files[0]));
    } else if (name === "images") {
      setFormData(prev => ({ ...prev, images: [...files] }));
      setPreviewImages(Array.from(files).map(file => URL.createObjectURL(file)));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!config) return;

    const data = new FormData();
    data.append("year", formData.year);
    data.append("title", formData.title);
    if (formData.tab_image) data.append("tab_image", formData.tab_image);
    if (formData.video) data.append("video", formData.video);
    formData.images.forEach(img => data.append("images[]", img));

    const url = mode === "add"
      ? `${config.BASE_URL}${config.ADD_GALLERY}`
      : `${config.BASE_URL}${config.UPDATE_GALLERY}`;

    try {
      const res = await fetch(url, { method: "POST", body: data });
      const result = await res.json();
      setMessage(result.message || "Operation completed");

      if (mode === "add") {
        setFormData({ year: "", title: "", tab_image: null, video: null, images: [] });
        setPreviewTabImage(null); setPreviewVideo(null); setPreviewImages([]);
      }
    } catch (err) {
      console.error(err);
      setMessage("Server error, please try again later.");
    }
  };

  const handleSelectUpdate = (title) => {
    const item = galleryData.find(g => g.title === title);
    if (!item) return;

    setFormData({ year: item.year || "", title: item.title || "", tab_image: null, video: null, images: [] });

    const basePath = `/Gallery_page_images/${item.year}/`;
    setPreviewTabImage(item.tab_image ? basePath + item.tab_image : null);
    setPreviewVideo(item.video ? basePath + item.video : null);
    setPreviewImages(item.images ? item.images.map(img => basePath + img) : []);
  };

  return (
    <div className="gallery-manager">
      <h1>Gallery Manager</h1>

      <div className="mode-selector">
        <button onClick={() => setMode("add")} className={mode === "add" ? "active" : ""}>Add</button>
        <button onClick={() => setMode("update")} className={mode === "update" ? "active" : ""}>Update</button>
      </div>

      {mode === "update" && (
        <div className="update-select">
          <label>Select Item to Update:</label>
          <select value={formData.title} onChange={(e) => { setFormData(prev => ({ ...prev, title: e.target.value })); handleSelectUpdate(e.target.value); }}>
            <option value="">-- Select --</option>
            {galleryData.map(item => <option key={item.id} value={item.title}>{item.title}</option>)}
          </select>
        </div>
      )}

      <form onSubmit={handleSubmit} className="gallery-form">
        <div className="form-group">
          <label>Year</label>
          <input type="text" name="year" value={formData.year} onChange={handleChange} required />
        </div>

        {mode === "add" && (
          <div className="form-group">
            <label>Title</label>
            <input type="text" name="title" value={formData.title} onChange={handleChange} required />
          </div>
        )}

        <div className="form-group">
          <label>Tab Image</label>
          <input type="file" name="tab_image" accept="image/*" onChange={handleChange} />
          {previewTabImage && <img src={previewTabImage} alt="tab preview" className="preview-image" />}
        </div>

        <div className="form-group">
          <label>Video</label>
          <input type="file" name="video" accept="video/*" onChange={handleChange} />
          {previewVideo && <video src={previewVideo} controls className="preview-video" />}
        </div>

        <div className="form-group">
          <label>Images (Multiple)</label>
          <input type="file" name="images" accept="image/*" multiple onChange={handleChange} />
          <div className="preview-multiple-images">
            {previewImages.map((img, idx) => <img key={idx} src={img} alt={`preview ${idx}`} className="preview-image" />)}
          </div>
        </div>

        <button type="submit">{mode === "add" ? "Add Item" : "Update Item"}</button>
      </form>

      {message && <p className="status-message">{message}</p>}
    </div>
  );
};

export default GalleryManager;
